import { Input } from 'antd';
import { InputProps } from 'antd/lib/input';
import React from 'react';
import styled from 'styled-components';

// tslint:disable-next-line: no-empty-interface
interface IAppInputProps extends InputProps {
  value?: string;
  label?: string;
  wrapperClassName?: string;
  inputRef?: any;
  placeholder?: string;
}

const StyledInputWrapper = styled.div`
  .ant-input {
    border: 1px solid ${({ theme }) => theme.colors.lightGray};
    width: 100%;
    height: 55px;
    padding: 18px 16px 18px;
    border-radius: 8px;
    font-size: ${({ theme }) => theme.fonts.fontSizes.fontSize16}px;
    margin-bottom: 10px;
  }

  .ant-form-item-explain-error {
    font-size: ${({ theme }) => theme.fonts.fontSizes.fontSize12}px;
  }

  .ant-input-status-error {
    color: ${({ theme }) => theme.colors.black};
  }
`;

const AppInput: React.FunctionComponent<IAppInputProps> = (props) => {
  const { className, inputRef, value, ...resProps } = props;

  const inputProps = {
    bordered: false,
    className,
    ref: inputRef,
    value: value || ``,
    ...resProps
  };

  return (
    <StyledInputWrapper>
      <Input
        placeholder={props.placeholder ? props.placeholder : props.label}
        {...inputProps}
      />
    </StyledInputWrapper>
  );
};

export default AppInput;
